"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PatientIntakeForm = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _lodash = require("lodash");
var _scrollTo = _interopRequireDefault(require("antd/es/_util/scrollTo"));
var _classnames = _interopRequireDefault(require("classnames"));
var _utils = require("../../utils");
var _types = require("../../types");
var _components = require("../../components");
var _api = require("./api");
var _PatientSurvey = require("../PatientSurvey");
var _PrescreenerSurvey = _interopRequireDefault(require("./PrescreenerSurvey"));
var _IntakeSurvey = _interopRequireDefault(require("./IntakeSurvey"));
var _AssessmentSurvey = _interopRequireDefault(require("./AssessmentSurvey/AssessmentSurvey"));
var _IntakeSummary = _interopRequireDefault(require("./IntakeSummary"));
var _PHYSICIAN_COMMENTS_Q;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var SURVEY_CARD_MARGIN_TOP = 24;
var PHYSICIAN_COMMENTS_QUESTION_NAMES_BY_SURVEY_TYPE = (_PHYSICIAN_COMMENTS_Q = {}, _defineProperty(_PHYSICIAN_COMMENTS_Q, _types.SurveyTypesEnum.Prescreening, _utils.DSM5_PHYSICIAN_COMMENT_QUESTION_NAME), _defineProperty(_PHYSICIAN_COMMENTS_Q, _types.SurveyTypesEnum.Intake, _utils.MEDICAL_INTAKE_PHYSICIAN_COMMENT_QUESTION_NAME), _PHYSICIAN_COMMENTS_Q);
var getPhysicianComment = function getPhysicianComment(surveyType, assessmentAnswers) {
  var questionAnswer = (0, _lodash.find)(assessmentAnswers, function (answer) {
    return answer.question.name === PHYSICIAN_COMMENTS_QUESTION_NAMES_BY_SURVEY_TYPE[surveyType];
  });
  return (questionAnswer === null || questionAnswer === void 0 ? void 0 : questionAnswer.answer[0]) || '';
};
var Anchors = /*#__PURE__*/function (Anchors) {
  Anchors["IntakeSummary"] = "intake-summary";
  Anchors["Dsm5"] = "dsm5";
  Anchors["MedicalHistory"] = "medical_history";
  Anchors["PhysicianAssessment"] = "physician_assessment";
  return Anchors;
}(Anchors || {});
var PatientIntakeForm = function PatientIntakeForm(_ref) {
  var patient = _ref.patient,
    isActiveView = _ref.isActiveView,
    data = _ref.data;
  var history = (0, _reactRouterDom.useHistory)();
  var location = (0, _reactRouterDom.useLocation)();
  var activeAnchor = location.hash.replace('#', '');
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    foreignSections = _useState2[0],
    setForeignSections = _useState2[1];
  var _useIsUsaStateActive = (0, _utils.useIsUsaStateActive)(patient.address.state),
    isPatientStateActive = _useIsUsaStateActive.active;
  var dsm5Survey = (0, _PatientSurvey.usePatientSurvey)({
    patientId: patient.id,
    surveyType: _types.SurveyTypesEnum.Prescreening
  });
  var intakeSurveyInternal = (0, _PatientSurvey.usePatientSurvey)({
    patientId: data !== null && data !== void 0 && data.intakeSurvey ? null : patient.id,
    surveyType: _types.SurveyTypesEnum.Intake
  });
  var intakeSurvey = (data === null || data === void 0 ? void 0 : data.intakeSurvey) || intakeSurveyInternal;
  var assessmentSurvey = (0, _PatientSurvey.usePatientSurvey)({
    patientId: patient.id,
    surveyType: _types.SurveyTypesEnum.PhysicianAssessment,
    setForeignSections: setForeignSections
  });
  var loading = !dsm5Survey.survey && !intakeSurvey.survey && !assessmentSurvey.survey;
  // Intake summary refers to the new medical intake created for 2024-billing
  var hasIntakeSummary = !!intakeSurvey.patientSurvey && intakeSurvey.patientSurvey.surveyId >= _utils.BILLING_CHANGES_INTAKE_SURVEY_ID;
  // Intake survey refers to previous versions of the medical intake before 2024-billing
  var hasIntakeSurvey = !!intakeSurvey.patientSurvey && intakeSurvey.patientSurvey.surveyId < _utils.BILLING_CHANGES_INTAKE_SURVEY_ID;
  var hasDsm5Survey = !!dsm5Survey.patientSurvey;
  var hasAssessmentSurvey = !!assessmentSurvey.patientSurvey;
  var isNewPatientAfter2024Billing = !hasDsm5Survey && !hasAssessmentSurvey && !hasIntakeSurvey;
  var onGoToAnchor = function onGoToAnchor(key) {
    history.push("".concat(location.pathname, "#").concat(key));
  };

  // 'isActiveView' checks if tab is active and visible now
  (0, _react.useEffect)(function () {
    var isValidAnchor = Object.values(Anchors).includes(activeAnchor);
    if (isActiveView) {
      if (activeAnchor && !isValidAnchor || !activeAnchor) {
        history.replace(hasIntakeSummary ? "".concat(location.pathname, "#").concat(Anchors.IntakeSummary) : "".concat(location.pathname));
        return;
      }
      if (activeAnchor && !loading) {
        // Wait until target survey UI is expanded and other surveys are collapsed
        setTimeout(function () {
          var target = document.querySelector("#".concat(activeAnchor));
          // If patient does not have the target survey, UI is not rendered
          if (!target) {
            return;
          }
          var offset = target.offsetTop || 0;
          // Don't scroll to edge of section, leave some margin at top
          (0, _scrollTo.default)(offset - SURVEY_CARD_MARGIN_TOP, {
            getContainer: function getContainer() {
              return document.querySelector('.intake-form');
            }
          });
        }, 200);
      }
    }
  }, [isActiveView, activeAnchor, loading, hasIntakeSummary]);
  (0, _react.useEffect)(function () {
    var layoutContent = document.querySelector('.LayoutContent');
    if (isActiveView && layoutContent) {
      layoutContent.classList.add('overflow-hidden');
    }
    if (!isActiveView && layoutContent) {
      layoutContent.classList.remove('overflow-hidden');
    }
  }, [isActiveView]);
  var _usePatientSurveysCal = (0, _api.usePatientSurveysCalculatedResults)(patient, dsm5Survey),
    disorder = _usePatientSurveysCal.disorder,
    historyOfIllness = _usePatientSurveysCal.historyOfIllness;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('--tag-intake-form-tabs', 'flex justify-center items-end h-intake-form-tabs-height px-[32px] bg-grey-10')
  }, /*#__PURE__*/_react.default.createElement(_components.MonumentTabs, {
    activeKey: activeAnchor,
    onChange: function onChange(key) {
      return onGoToAnchor(key);
    }
  }, hasIntakeSummary && /*#__PURE__*/_react.default.createElement(_components.TabPane, {
    label: "Intake Summary",
    key: Anchors.IntakeSummary
  }), hasDsm5Survey && /*#__PURE__*/_react.default.createElement(_components.TabPane, {
    label: "DSM-5",
    key: Anchors.Dsm5
  }), hasIntakeSurvey && /*#__PURE__*/_react.default.createElement(_components.TabPane, {
    label: "Medical Intake",
    key: Anchors.MedicalHistory
  }), hasAssessmentSurvey && /*#__PURE__*/_react.default.createElement(_components.TabPane, {
    label: "".concat((0, _utils.getRoleName)(_utils.UserRoles.Doctor), " Assessment"),
    key: Anchors.PhysicianAssessment
  }))), /*#__PURE__*/_react.default.createElement("div", {
    // NOTE: relative positioning needed so that .intake-form scrolls properly to anchor
    className: (0, _classnames.default)('relative flex justify-center overflow-auto', 'h-[calc(100vh-theme(spacing.app-header-height)-theme(spacing.patient-details-tabs-height)-theme(spacing.intake-form-tabs-height))]')
  }, isActiveView && /*#__PURE__*/_react.default.createElement("div", {
    className: "intake-form px-[24px] h-full w-full overflow-auto"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "w-full mx-auto max-w-[488px]",
    style: {
      padding: "".concat(SURVEY_CARD_MARGIN_TOP, "px 0")
    }
  }, hasIntakeSummary && /*#__PURE__*/_react.default.createElement("div", {
    id: Anchors.IntakeSummary
  }, /*#__PURE__*/_react.default.createElement(_IntakeSummary.default, {
    surveyData: intakeSurvey,
    expanded: activeAnchor === Anchors.IntakeSummary,
    onClickDetail: function onClickDetail() {
      return onGoToAnchor(Anchors.IntakeSummary);
    }
  })), hasDsm5Survey && /*#__PURE__*/_react.default.createElement("div", {
    id: Anchors.Dsm5
  }, /*#__PURE__*/_react.default.createElement(_PrescreenerSurvey.default, {
    surveyData: dsm5Survey,
    disorder: disorder,
    expanded: activeAnchor === Anchors.Dsm5,
    physicianComment: getPhysicianComment(_types.SurveyTypesEnum.Prescreening, assessmentSurvey.patientSurveyAnswers),
    onClickDetail: function onClickDetail() {
      return onGoToAnchor(Anchors.Dsm5);
    },
    foreignSection: foreignSections && foreignSections[_utils.DSM5_PHYSICIAN_COMMENT_SECTION_NAME],
    foreignSectionPatientAnswers: assessmentSurvey.patientSurveyAnswers
  })), hasIntakeSurvey && /*#__PURE__*/_react.default.createElement("div", {
    id: Anchors.MedicalHistory
  }, /*#__PURE__*/_react.default.createElement(_IntakeSurvey.default, {
    surveyData: intakeSurvey,
    expanded: activeAnchor === Anchors.MedicalHistory,
    physicianComment: getPhysicianComment(_types.SurveyTypesEnum.Intake, assessmentSurvey.patientSurveyAnswers),
    onClickDetail: function onClickDetail() {
      return onGoToAnchor(Anchors.MedicalHistory);
    },
    foreignSection: foreignSections && foreignSections[_utils.MEDICAL_INTAKE_PHYSICIAN_COMMENT_SECTION_NAME],
    foreignSectionPatientAnswers: assessmentSurvey.patientSurveyAnswers
  })), hasAssessmentSurvey && /*#__PURE__*/_react.default.createElement("div", {
    id: Anchors.PhysicianAssessment
  }, /*#__PURE__*/_react.default.createElement(_AssessmentSurvey.default, {
    patientId: patient.id,
    isPatientStateActive: isPatientStateActive,
    surveyData: assessmentSurvey,
    intakeData: intakeSurvey,
    historyOfIllness: historyOfIllness,
    expanded: activeAnchor === Anchors.PhysicianAssessment,
    onClickDetail: function onClickDetail() {
      return onGoToAnchor(Anchors.PhysicianAssessment);
    }
  })), !loading && isNewPatientAfter2024Billing && /*#__PURE__*/_react.default.createElement(_components.Alert, {
    type: _components.AlertTypeEnum.Alert,
    className: "w-full mb-[50px]"
  }, "The intake form has been updated. This patient hasn\u2019t completed the DSM-5 or previous medical intake. Please gather any necessary information during your session.")))));
};
exports.PatientIntakeForm = PatientIntakeForm;